import React from "react"

import styled from "styled-components"
import { Styles } from "../config"

const getVariantPallet = ({ variant }) => {
	if (variant === "t1" || variant === "t2" || variant === "title") {
		return "textPrimary"
	} else if (variant === "t3" || variant === "t4" || variant === "t5") {
		return "textSecondary"
	} else if ((variant = "t6" || variant === "t7")) {
		return "textTertiary"
	}
	return "textPrimary"
}

const TypographyRoot = (props) => React.createElement(props.component || "span", props, props.children)

const TypographyVessel = styled(TypographyRoot)`
	display: inline-block;
	margin: ${(props) => (props.margin ? props.margin : "0")};
	padding: ${(props) => (props.padding ? props.padding : "0")};
	text-align: ${(props) => props.textAlign || "left"};
	font-weight: ${({ bold, weight, variant }) =>
		bold ? "800" : Styles.FontWeight[weight] || Styles.FontSize[variant].weight};
	color: ${(props) =>
		props.color ? Styles.Color[props.color] : Styles.Color[getVariantPallet({ variant: props.variant })]};
	font-size: ${(props) => Styles.FontSize[props.variant]?.size}px;
	line-height: 1.5;
	-moz-osx-font-smoothing: grayscale;
	-webkit-font-smoothing: antialiased;

	@media only screen and (max-width: ${(props) => props.threshold}px) {
		*:first-child {
			display: none;
		}
		*:last-child {
			display: contents;
		}
	}

	@media only screen and (max-width: ${(props) => props.threshold}px) {
		font-size: ${(props) => Styles.FontSize[props.variant]?.mobileSize}px;
		text-align: ${(props) => (props.mobile ? "center" : props.textAlign || "left")};
	}
`

const Typography = (props) => {
	const { variant, className, children, style } = props

	return (
		<TypographyVessel
			{...props}
			variant={variant || "t1"}
			className={className || ""}
			style={{
				transition: "all 600 ease-in-out",
				...style
			}}
		>
			{children}
		</TypographyVessel>
	)
}

export default Typography
